import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/videos';

export default function CTASection() {
  return (
    <section className="w-full py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20texture%20with%20flowing%20coral%20and%20amber%20waves%2C%20cinematic%20atmosphere%2C%20soft%20and%20elegant%20visual%20design%2C%20minimal%20artistic%20background%20with%20motion%20blur%20effect&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 via-primary-800/85 to-primary-900/90"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50 mb-4">
            准备好开启你的
            <span className="text-accent-400">国产视频</span>
            探索之旅了吗？
          </h2>
          <p className="text-sm md:text-base text-background-200/90 mb-8 md:mb-10 max-w-xl mx-auto leading-relaxed">
            加入数百万观众的行列，发现优质国产原创视频内容。无论你是创作者还是观众，这里都有属于你的精彩。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-foreground-950 rounded-lg text-sm md:text-base font-semibold whitespace-nowrap hover:bg-accent-400 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-compass-3-line mr-2"></i>
              开始探索
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/25 rounded-lg text-sm md:text-base font-semibold whitespace-nowrap hover:bg-background-50/25 transition-all duration-200 cursor-pointer"
            >
              <i className="ri-information-line mr-2"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
              常见问题
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              你可能想了解的
            </h2>
            <p className="text-sm text-foreground-500">
              关于国产视频精选平台的常见问题解答
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-100/60 rounded-xl overflow-hidden"
              >
                <button
                  type="button"
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                >
                  <span className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    openIndex === index
                      ? 'bg-primary-500 text-background-50 rotate-45'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5 animate-in fade-in slide-in-from-top-2 duration-200">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}